import { render, staticRenderFns } from "./AdminNavigation.vue?vue&type=template&id=890c09c6&scoped=true"
import script from "./AdminNavigation.vue?vue&type=script&lang=js"
export * from "./AdminNavigation.vue?vue&type=script&lang=js"
import style0 from "./AdminNavigation.vue?vue&type=style&index=0&id=890c09c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890c09c6",
  null
  
)

export default component.exports